export enum Access {
  None = "None",
  Read = "Read",
  Edit = "Edit",
  Full = "Full",
}
